import { defineComponent } from 'vue'

export const VNodes = defineComponent({
  setup(_, { attrs }) {
    return () => attrs.vnodes
  }
})
